import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import { useMembership } from "./use-membership";
import { useGetOrganizationPolicies } from "@/queries/organization-queries";
import type { PlainOrganizationPolicies } from "@/queries/organization-queries";
import type { PlainMessage } from "node_modules/@bufbuild/protobuf/dist/esm/message";
import type { AccountMembership } from "gitpod-next-api/gitpod/v1/account_pb";

/**
 * Logic function to determine if a user requires a project to create an environment
 * Exported for testing purposes
 */
export function requireProjects(
    membership: PlainMessage<AccountMembership> | undefined,
    policies: PlainOrganizationPolicies | undefined,
): boolean {
    if (!membership) return false;

    // Admins can create environments without projects
    if (membership.userRole === OrganizationRole.ADMIN) {
        return false;
    }

    // For regular members, check organization policies
    return !!policies?.membersRequireProjects;
}

/**
 * Hook to determine whether the current user requires a project to create an environment based on:
 * - User's membership role (admin = false)
 * - Organization policies for regular members
 */
export const useRequireProject = (): { isPending: boolean; requireProjects: boolean } => {
    const { membership, isPending: isMembershipPending } = useMembership();
    const { data: policies, isLoading: isPoliciesLoading } = useGetOrganizationPolicies();

    const isPending = isMembershipPending || isPoliciesLoading;

    return {
        isPending,
        requireProjects: requireProjects(membership, policies),
    };
};
